export default __webpack_public_path__ + "static/media/profileFemke@2x.6c2dbb72.png";